module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "checklist"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm._f("translate")('Summary')))]), _vm._v(" "), _c('ul', {
    staticClass: "checklist-items"
  }, [_c('li', {
    staticClass: "checklist-item",
    class: {
      'checklist-item-success': _vm.mazlicek.jmeno.valid, 'checklist-item-danger': !_vm.mazlicek.jmeno.valid, 'active-item': _vm.mazlicek.step.current === 1
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'jmenomazlicka'
      }
    }
  }, [_c('div', {
    staticClass: "checklist-label"
  }, [_vm._v(_vm._s(_vm._f("translate")('Name of the pet')))]), _vm._v(" "), (_vm.mazlicek.jmeno.valid) ? _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v(_vm._s(_vm.mazlicek.jmeno.value))]) : _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v(_vm._s(_vm._f("translate")('Unfilled')))])])], 1), _vm._v(" "), _c('li', {
    staticClass: "checklist-item",
    class: {
      'checklist-item-success': _vm.mazlicek.step.current >= 2, 'active-item': _vm.mazlicek.step.current === 2
    }
  }, [(_vm.mazlicek.step.current >= 2) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'rasa'
      }
    }
  }, [_c('div', {
    staticClass: "checklist-label"
  }, [_vm._v(_vm._s(_vm._f("translate")('Breed')))]), _vm._v(" "), (_vm.mazlicek.rasa.typ === 'app_rasa') ? _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v("\n                        " + _vm._s(_vm.mazlicek.rasa.autocomplete.keyword) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.mazlicek.rasa.typ === 'app_velikost' && _vm.velikost && _vm.velikost.title) ? _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v("\n                        " + _vm._s(_vm.velikost.title) + "\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.mazlicek.rasa.typ && (_vm.mazlicek.rasa.typ === 'app_velikost' && _vm.velikost && _vm.velikost.title)) ? _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v("Nevyplněno")]) : _vm._e()]) : _c('span', [_c('div', {
    staticClass: "checklist-label"
  }, [_vm._v(_vm._s(_vm._f("translate")('Breed')))]), _vm._v(" "), (_vm.mazlicek.rasa.typ === 'app_rasa') ? _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v("\n                        " + _vm._s(_vm.mazlicek.rasa.autocomplete.keyword) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.mazlicek.rasa.typ === 'app_velikost' && _vm.velikost && _vm.velikost.title) ? _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v("\n                        " + _vm._s(_vm.velikost.title) + "\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.mazlicek.rasa.valid) ? _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("translate")('Breed')) + "\n                    ")]) : _vm._e()])], 1), _vm._v(" "), _c('li', {
    staticClass: "checklist-item",
    class: {
      'checklist-item-success': _vm.mazlicek.fotografie.valid, 'checklist-item-danger': !_vm.mazlicek.fotografie.valid, 'active-item': _vm.mazlicek.step.current === 3
    }
  }, [(_vm.mazlicek.step.current >= 3) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'fotografie'
      }
    }
  }, [_c('div', {
    staticClass: "checklist-label"
  }, [_vm._v(_vm._s(_vm._f("translate")('Photo')))]), _vm._v(" "), (_vm.mazlicek.fotografie.typ === 'foto' || _vm.mazlicek.fotografie.typ == 'ikona') ? _c('div', [_c('div', {
    staticClass: "checklist-value"
  }, [_vm._v(_vm._s(_vm._f("translate")('Yes')))])]) : _vm._e(), _vm._v(" "), (!_vm.mazlicek.fotografie.valid) ? _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v(_vm._s(_vm._f("translate")('Unfilled')))]) : _vm._e()]) : _c('span', [_c('div', {
    staticClass: "checklist-label"
  }, [_vm._v(_vm._s(_vm._f("translate")('Photo')))]), _vm._v(" "), (_vm.mazlicek.fotografie.typ === 'foto' || _vm.mazlicek.fotografie.typ == 'ikona') ? _c('div', [_c('div', {
    staticClass: "checklist-value"
  }, [_vm._v("Ano")])]) : _vm._e(), _vm._v(" "), (!_vm.mazlicek.fotografie.valid) ? _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v(_vm._s(_vm._f("translate")('Yes')))]) : _vm._e()])], 1), _vm._v(" "), _c('li', {
    staticClass: "checklist-item",
    class: {
      'checklist-item-success': _vm.mazlicek.narozeniny.valid, 'checklist-item-danger': !_vm.mazlicek.narozeniny.valid, 'active-item': _vm.mazlicek.step.current === 4
    }
  }, [(_vm.mazlicek.step.current >= 4) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'narozeniny'
      }
    }
  }, [_c('div', {
    staticClass: "checklist-label"
  }, [_vm._v(_vm._s(_vm._f("translate")('Birthday')))]), _vm._v(" "), (_vm.mazlicek.narozeniny.valid) ? _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v(_vm._s(_vm.formatDatumNarozeni))]) : _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v(_vm._s(_vm._f("translate")('Unfilled')))])]) : _c('span', [_c('div', {
    staticClass: "checklist-label"
  }, [_vm._v(_vm._s(_vm._f("translate")('Birthday')))]), _vm._v(" "), (_vm.mazlicek.narozeniny.valid) ? _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v(_vm._s(_vm.formatDatumNarozeni))]) : _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v(_vm._s(_vm._f("translate")('Unfilled')))])])], 1), _vm._v(" "), _c('li', {
    staticClass: "checklist-item",
    class: {
      'checklist-item-success': _vm.mazlicek.pohlavi.valid, 'checklist-item-danger': !_vm.mazlicek.pohlavi.valid, 'active-item': _vm.mazlicek.step.current === 5
    }
  }, [(_vm.mazlicek.step.current >= 5) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'pohlavi'
      }
    }
  }, [_c('div', {
    staticClass: "checklist-label"
  }, [_vm._v(_vm._s(_vm._f("translate")('Gender')))]), _vm._v(" "), (_vm.mazlicek.pohlavi.valid && _vm.mazlicek.pohlavi.value === 'fena') ? _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v(_vm._s(_vm._f("translate")('Bitch')) + "\n              ")]) : (_vm.mazlicek.pohlavi.valid && _vm.mazlicek.pohlavi.value === 'pes') ? _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v(_vm._s(_vm._f("translate")('Dog')) + "\n              ")]) : _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v(_vm._s(_vm._f("translate")('Unfilled')))])]) : _c('span', [_c('div', {
    staticClass: "checklist-label"
  }, [_vm._v(_vm._s(_vm._f("translate")('Gender')))]), _vm._v(" "), (_vm.mazlicek.pohlavi.valid && _vm.mazlicek.pohlavi.value === 'fena') ? _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v(_vm._s(_vm._f("translate")('Bitch')))]) : (_vm.mazlicek.pohlavi.valid && _vm.mazlicek.pohlavi.value === 'pes') ? _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v(_vm._s(_vm._f("translate")('Dog')))]) : _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v(_vm._s(_vm._f("translate")('Unfilled')))])])], 1), _vm._v(" "), _c('li', {
    staticClass: "checklist-item",
    class: {
      'checklist-item-success': _vm.mazlicek.hmotnostkondice.valid, 'checklist-item-danger': !_vm.mazlicek.hmotnostkondice.valid, 'active-item': _vm.mazlicek.step.current === 6
    }
  }, [(_vm.mazlicek.step.current >= 6) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'hmotnostkondice'
      }
    }
  }, [_c('div', {
    staticClass: "checklist-label"
  }, [_vm._v(_vm._s(_vm._f("translate")('Weight and fitness')))]), _vm._v(" "), (_vm.mazlicek.hmotnostkondice.valid) ? _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v("\n                        " + _vm._s(_vm.kondiceValue) + "\n")]) : _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v(_vm._s(_vm._f("translate")('Unfilled')))])]) : _c('span', [_c('div', {
    staticClass: "checklist-label"
  }, [_vm._v(_vm._s(_vm._f("translate")('Weight and fitness')))]), _vm._v(" "), (_vm.mazlicek.hmotnostkondice.valid) ? _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v("\n                        " + _vm._s(_vm.kondiceValue) + "\n                    ")]) : _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v(_vm._s(_vm._f("translate")('Unfilled')))])])], 1), _vm._v(" "), _c('li', {
    staticClass: "checklist-item",
    class: {
      'checklist-item-success': _vm.mazlicek.pohyb.valid || _vm.mazlicek.jeStene, 'checklist-item-danger': !_vm.mazlicek.pohyb.valid && !_vm.mazlicek.jeStene, 'active-item': _vm.mazlicek.step.current === 7
    }
  }, [(_vm.mazlicek.step.current >= 7) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'pohyb'
      }
    }
  }, [_c('div', {
    staticClass: "checklist-label"
  }, [_vm._v(_vm._s(_vm._f("translate")('Activity')))]), _vm._v(" "), _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v(_vm._s(_vm._f("translate")(_vm.aktivitaValue)))])]) : _c('span', [_c('div', {
    staticClass: "checklist-label"
  }, [_vm._v(_vm._s(_vm._f("translate")('Activity')))]), _vm._v(" "), _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v(_vm._s(_vm._f("translate")(_vm.aktivitaValue)))])])], 1), _vm._v(" "), _c('li', {
    staticClass: "checklist-item",
    class: {
      'checklist-item-success': _vm.mazlicek.alergie.valid, 'checklist-item-danger': !_vm.mazlicek.alergie.valid, 'active-item': _vm.mazlicek.step.current === 8
    }
  }, [(_vm.mazlicek.step.current >= 8) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'alergie'
      }
    }
  }, [_c('div', {
    staticClass: "checklist-label"
  }, [_vm._v(_vm._s(_vm._f("translate")('Increased sensitivity')))]), _vm._v(" "), (_vm.mazlicek.alergie.valid) ? _c('div', {
    staticClass: "checklist-value"
  }, [(_vm.mazlicek.alergie.alergie) ? _c('span', [_vm._v(_vm._s(_vm._f("translate")('Yes')))]) : _c('span', [_vm._v(_vm._s(_vm._f("translate")('No')))])]) : _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v(_vm._s(_vm._f("translate")('Unfilled')))])]) : _c('span', [_c('div', {
    staticClass: "checklist-label"
  }, [_vm._v(_vm._s(_vm._f("translate")('Increased sensitivity')))]), _vm._v(" "), (_vm.mazlicek.alergie.valid) ? _c('div', {
    staticClass: "checklist-value"
  }, [(_vm.mazlicek.alergie.alergie) ? _c('span', [_vm._v(_vm._s(_vm._f("translate")('Yes')))]) : _c('span', [_vm._v(_vm._s(_vm._f("translate")('No')))])]) : _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v(_vm._s(_vm._f("translate")('Unfilled')))])])], 1), _vm._v(" "), _c('li', {
    staticClass: "checklist-item",
    class: {
      'checklist-item-success': _vm.mazlicek.suroviny.valid, 'checklist-item-danger': !_vm.mazlicek.suroviny.valid, 'active-item': _vm.mazlicek.step.current === 9
    }
  }, [(_vm.mazlicek.step.current >= 9) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'suroviny'
      }
    }
  }, [_c('div', {
    staticClass: "checklist-label"
  }, [_vm._v(_vm._s(_vm._f("translate")('Ingredients')))]), _vm._v(" "), (_vm.mazlicek.suroviny.valid) ? _c('div', {
    staticClass: "checklist-value"
  }, [(_vm.mazlicek.suroviny.valid && _vm.slozkaItems && _vm.slozkaItems.length >= 2) ? _c('span', [_c('span', [_vm._v(_vm._s(_vm.slozkaItems[0].title))]), _vm._v(",\n                            "), _c('span', [_vm._v(_vm._s(_vm.slozkaItems[1].title))])]) : _vm._e()]) : _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v(_vm._s(_vm._f("translate")('Unfilled')))])]) : _c('span', [_c('div', {
    staticClass: "checklist-label"
  }, [_vm._v(_vm._s(_vm._f("translate")('Ingredients')))]), _vm._v(" "), (_vm.mazlicek.suroviny.valid) ? _c('div', {
    staticClass: "checklist-value"
  }, [(_vm.mazlicek.suroviny.valid && _vm.slozkaItems && _vm.slozkaItems.length >= 2) ? _c('span', [_c('span', [_vm._v(_vm._s(_vm.slozkaItems[0].title))]), _vm._v(",\n                            "), _c('span', [_vm._v(_vm._s(_vm.slozkaItems[1].title))])]) : _vm._e()]) : _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v(_vm._s(_vm._f("translate")('Unfilled')))])])], 1)]), _vm._v(" "), (_vm.lastStep) ? _c('div', {
    staticClass: "objednavka-btn"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.objednatBtn()
      }
    }
  }, [_vm._v(_vm._s(_vm._f("translate")('Go to order')))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13546774","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Checklist.vue
// module id = 540
// module chunks = 1